import { render, staticRenderFns } from "./ulflex.vue?vue&type=template&id=79a85811&scoped=true"
import script from "./ulflex.vue?vue&type=script&lang=js"
export * from "./ulflex.vue?vue&type=script&lang=js"
import style0 from "./ulflex.vue?vue&type=style&index=0&id=79a85811&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79a85811",
  null
  
)

export default component.exports